/* 
    Importing the components and dependencies for the view
*/
import { mapGetters } from "vuex";
import NavDrawer from "./components/AppComponents/NavDrawer/NavDrawer";
import ToolBar from "./components/AppComponents/ToolBar/ToolBar";
import snackBar from "./components/SnackBarComponent/SnackBarComponent";

import { clearStorage } from "./config/app.config.js";
import Chat from "./components/Chat/Home";

import "./assets/ReportViewer/js/telerikReportViewer.kendo-13.0.19.222.min.js";

/* 
Logics for the App.vue
*/
export default {
  name: "App",

  components: {
    NavDrawer,
    ToolBar,
    Chat,
    snackBar
  },

  data() {
    return {
      drawer: true,
      mini: true,
      userDetails: "",
      drawer1: false,
      showLoader: false,
      fab: false,
      fab1: false,
      isPermanent: true,
      isHidden: false,
      sheet: false,
      isPopup: false,
      areaTeamBranchList: [],
      teams: [],
      branches: [],
      selectedArea: {},
      selectedTeam: {},
      selectedBranch: {},
      isLoadingFirstTime: true,
      teamDropDownErrorMessage: "",
      branchDropDownErrorMessage: ""
    };
  },

  computed: {
    listToShow() {
      if (this.getReportMenus.length > 2) {
        return this.getReportMenus.slice(0, 2);
      }
      return this.getReportMenus;
    },

    moreList() {
      if (this.getReportMenus.length > 2) {
        return this.getReportMenus.slice(2, this.getReportMenus.length);
      }
      return [];
    },

    showAreaDropdown() {
      if (this.areaTeamBranchList.length > 1) {
        return true;
      }
      return false;
    },

    showTeamDropDown() {
      if (this.areaTeamBranchList.length < 1) return false;
      if (this.areaTeamBranchList.length == 1) {
        if (this.areaTeamBranchList[0].listTeams.length == 1) {
          return false;
        }
      }
      return true;
    },

    showOfficeDropDown() {
      if (this.areaTeamBranchList.length < 1) return false;
      if (this.areaTeamBranchList.length == 1) {
        if (this.areaTeamBranchList[0].listTeams.length == 1) {
          if (this.areaTeamBranchList[0].listTeams[0].listOffices.length == 1) {
            return false;
          }
        }
      }
      return true;
    },

    ...mapGetters([
      "isLoading",
      "getReportMenus",
      "getActiveReportMenu",
      "getUserDetails",
      "getSelectedArea",
      "getSelectedTeam",
      "getSelectedBranch",
      "getAllAreaTeamBranch"
    ])
  },

  async mounted() {
    let context = this;

    //Handling the visiblity of the mini drawer in mobile
    window.addEventListener("resize", this.MenuBarVisibility);
    this.MenuBarVisibility();

    this.$router.app.$on("menutoggle", function(val) {
      context.drawer1 = val;
    });

    ///To open Area Team Popup
    this.$router.app.$on("openAreaTeamBranchPopup", function(teamorBranch) {
      if (teamorBranch.includes("team")) {
        context.teamDropDownErrorMessage = "Please select a team";
      } else {
        context.branchDropDownErrorMessage = "Please select a branch";
      }

      context.isPopup = true;
    });

    //To Get the userdetails after login
    //Emiting from the Login.controller
  },
  methods: {
    closeAreaTeamBranchPopup() {
      this.isPopup = false;
      this.teamDropDownErrorMessage = "";
      this.branchDropDownErrorMessage = "";
    },
    setReportType(reportType) {
      this.sheet = false;
      this.$store.commit("setActiveReportMenu", reportType);
      this.$router.push({ name: "Sales", query: reportType });
    },

    Logout() {
      clearStorage();
      this.$store.commit("resetFilterStore");
      this.sheet = false;
      this.$router.push("login");
    },

    MenuBarVisibility() {
      if (window.innerWidth < 1025) {
        this.isPermanent = false;
        this.isHidden = true;
      } else {
        this.isPermanent = true;
        this.isHidden = false;
      }
    },

    changeArea(selectedArea) {
      this.$store.dispatch("changeArea", selectedArea);
      this.teams = selectedArea.listTeams;
      if (this.teams.length > 0) {
        this.changeTeam(this.teams[0]);
      }
    },

    changeTeam(selectedTeam) {
      this.teamDropDownErrorMessage = "";
      this.branchDropDownErrorMessage = "";
      this.$store.dispatch("changeTeam", selectedTeam);
      this.branches = selectedTeam.listOffices;
      if (this.branches.length > 0) {
        this.changeBranch(this.branches[0]);
      }
    },

    changeBranch(selectedBranch) {
      this.teamDropDownErrorMessage = "";
      this.branchDropDownErrorMessage = "";
      this.$store.dispatch("changeBranch", selectedBranch);
    },

    getDefaultArea() {
      var defaultArea = this.getAllAreaTeamBranch.filter(
        x => x.Area == this.getUserDetails.area
      );

      if (defaultArea.length > 0) {
        return defaultArea[0];
      }
      return this.getAllAreaTeamBranch[0];
    },

    getDefaultTeam(selectedArea) {
      var defaultTeam = selectedArea.listTeams.filter(
        x => x.Team == this.getUserDetails.team
      );

      if (defaultTeam.length > 0) {
        return defaultTeam[0];
      }
      return selectedArea.listTeams[0];
    },

    getDefaultOffice(selectedTeam) {
      var defaultOffice = selectedTeam.listOffices.filter(
        x => x.Office == this.getUserDetails.office
      );
      if (defaultOffice.length > 0) {
        return defaultOffice[0];
      }
      return selectedTeam.listOffices[0];
    }
  },

  watch: {
    drawer1: function(val) {
      this.$router.app.$emit("showMessageCount", val);
    },

    getSelectedArea(newValue, oldValue) {
      this.selectedArea = newValue;
    },

    getSelectedTeam(newValue, oldValue) {
      this.selectedTeam = newValue;
    },

    getSelectedBranch(newValue, oldValue) {
      this.selectedBranch = newValue;
    },

    getAllAreaTeamBranch(newValue, oldValue) {
      this.areaTeamBranchList = newValue;
      if (newValue.length < 1) {
        return false;
      }

      // if (this.isLoadingFirstTime) {
      var defaultArea = this.getDefaultArea();
      this.changeArea(defaultArea);
      var defaultTeam = this.getDefaultTeam(defaultArea);
      this.changeTeam(defaultTeam);
      this.changeBranch(this.getDefaultOffice(defaultTeam));
      this.isLoadingFirstTime = false;
      // }
    }
  }
};
